import styled from 'styled-components';

export const ContainerStudies = styled.div`
  margin-top: 50px;

  table {
    margin-top: 20px;
  }

  td {
    height: 30px;
  }

  .filter {
    display: flex;
  }

  h2 {
    margin-bottom: 40px;
  }

  table {
    font-size: 13px !important;
  }

  th:nth-of-type(2) {
    width: 20vw;
  }
  th:nth-of-type(3) {
    width: 10vw;
  }
  th:nth-of-type(4) {
    width: 10vw;
  }
  @media (max-width: 1180px) {
    width: 100%;
    float: none !important;
    margin-left: 0px !important;
  }
`;

export const ContainerLoading = styled.div`
  height: calc(100vh - 7.5rem);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #2c3e50;
    text-align: center;
  }
`;
